import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "../turkeydrop/turkeydrop2025/turkeydrop2025.css";
import ShieldIMG from "../../assets/rhp-shield.png";
import ShieldFooterIMG from "../../assets/shield.png";

function buildInternalLink(pathname, search) {
  return {
    pathname,
    search: search || "",
  };
}

export default function SanDiegoSunsetPage({
  eventName = "San Diego event series",
  pageTitle = "San Diego Events",
}) {
  const location = useLocation();

  useEffect(() => {
    document.title = pageTitle;
  }, [pageTitle]);

  const nextEventLink = buildInternalLink("/pints-for-patriots", location.search);

  return (
    <>
      <main className="tdp-shell">
        <div
          className="tdp-bg"
          style={{ "--bg-url": `url(${ShieldIMG})` }}
          aria-hidden="true"
        />

        <section className="tdp-left">
          <span className="crumb">Road Home Program Events</span>
          <h1 className="tdp-title">{eventName}</h1>
          <p className="tdp-sub" style={{ maxWidth: 680 }}>
            This San Diego event series has concluded. Thank you to everyone who joined us and
            supported the Road Home Program.
          </p>

          <div className="tdp-block">
            <h3>What&apos;s next</h3>
            <p className="tdp-sub" style={{ marginTop: 0, maxWidth: 680 }}>
              Our next featured event is Pints for Patriots, a dual-location fundraising event in
              Beverly benefiting The Road Home Program.
            </p>
          </div>
        </section>

        <section className="tdp-right">
          <article className="tdp-card">
            <p
              style={{
                margin: 0,
                fontSize: 12,
                letterSpacing: ".08em",
                textTransform: "uppercase",
                color: "#2f6b49",
                fontWeight: 700,
              }}
            >
              Event Concluded
            </p>
            <h2 className="tdp-card-title" style={{ marginTop: 10 }}>
              Thank you for joining us in San Diego.
            </h2>
            <p className="tdp-card-sub" style={{ marginBottom: 16 }}>
              This landing page is now closed and no longer accepts RSVPs.
            </p>
            <p className="tdp-sub" style={{ marginTop: 0 }}>
              Follow the link below to see our current fundraiser and support the next event.
            </p>
            <Link className="tdp-submit" to={nextEventLink} style={{ display: "inline-flex" }}>
              See Our Next Event: Pints for Patriots
            </Link>
          </article>
        </section>
      </main>

      <footer className="tdp-footer" role="contentinfo">
        <div className="tdp-footer__inner">
          <div className="tdp-footer__brand">
            <img
              src={ShieldFooterIMG}
              alt=""
              aria-hidden="true"
              className="tdp-footer__shield"
              decoding="async"
            />
            <div className="tdp-footer__brandtext">
              <div className="tdp-footer__title">Road Home Program</div>
              <div className="tdp-footer__org">
                The National Center of Excellence for Veterans and Their Families at Rush
              </div>
              <div className="tdp-footer__contact">
                1645 W. Jackson Blvd., Suite 602, Chicago, IL 60612
                <span className="tdp-dot" aria-hidden>
                  •
                </span>
                <a href="tel:13129428387">(312) 942-8387 (VETS)</a>
              </div>
            </div>
          </div>

          <nav className="tdp-footer__nav" aria-label="Footer">
            <a href="https://roadhomeprogram.org/family-center/">Help for Families</a>
            <a href="https://roadhomeprogram.org/get-care/">Get Care</a>
            <a href="https://roadhomeprogram.org/accelerated-treatment-program/">
              Accelerated Treatment Program
            </a>
            <a href="https://roadhomeprogram.org/outpatient-program/">Outpatient Program</a>
            <a href="https://roadhomeprogram.org/outreach-and-events/">Outreach and Events</a>
            <a href="https://roadhomeprogram.org/contact-us/">General Information</a>
          </nav>

          <div className="tdp-footer__legal">
            © {new Date().getFullYear()} Road Home Program at Rush.
          </div>
        </div>
      </footer>
    </>
  );
}
